import React from "react";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("Application screen failed:", error, info);
  }

  render() {
    if (!this.state.failed) return this.props.children;

    return (
      <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center p-6">
        <div className="max-w-md rounded-2xl border border-white/10 bg-white/5 p-6 text-center">
          <h1 className="text-xl font-semibold">This screen hit a problem</h1>
          <p className="mt-2 text-sm text-slate-300">
            Your saved data is still available. Reload the screen to continue.
          </p>
          <button
            type="button"
            className="mt-5 rounded-xl bg-pink-500 px-5 py-2.5 font-medium"
            onClick={() => window.location.reload()}
          >
            Reload screen
          </button>
        </div>
      </div>
    );
  }
}
